import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Box,
    Paper,
    Typography,
    IconButton,
} from '@mui/material';
import { select2FA } from '../../store/twoFAlice';
import JwtService from '../../auth/services/jwtService';
import { showMessage } from 'app/store/fuse/messageSlice';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TwoFaSetupStepper from './TwoFaSetupStepper';
import { useNavigate, useLocation } from 'react-router-dom';

function TwoFaStepperPage() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const email = location?.state?.email;
    const password = location?.state?.password;

    const { verified } = useSelector(select2FA);

    useEffect(() => {
        if (verified) {
            // User is verified, login will be handled by JwtService
        }
    }, [verified]);

    const handleVerifySuccess = (res) => {
        if (!res?.errors) {
            JwtService.twoFaLogin(res);
        }
    };

    const handleVerifyError = (_errors) => {
        if (Array.isArray(_errors)) {
            _errors.forEach((error) => {
                if (error?.type == "blocked") {
                    dispatch(showMessage({ message: error?.message, variant: "error" }));
                } else if (error?.type == "deleted") {
                    dispatch(showMessage({ message: error?.message, variant: "error" }));
                } else if (error?.type == "2Fa") {
                    dispatch(showMessage({ message: error?.message, variant: "warn" }));
                    navigate("/enable-2fa", { state: { email, password } });
                } else if (error?.type == "2Fa Verify") {
                    dispatch(showMessage({ message: error.message, variant: "success" }));
                    navigate('/verify-2fa', { state: { email, password } });
                } else {
                    dispatch(showMessage({ message: error?.message || "Verification Failed", variant: "error" }));
                }
            });
        } else {
            dispatch(showMessage({ message: _errors || "Verification Failed", variant: "error" }));
        }
    };

    if (!email || !password) {
        return (
            <div className="flex flex-col items-center flex-auto min-w-0 sm:justify-center">
                <Paper
                    sx={{
                        width: '600px',
                        minHeight: '100%',
                        px: { xs: 2, sm: 4 },
                        py: { xs: 4, sm: 6 },
                        borderRadius: { xs: 0, sm: 2 },
                        boxShadow: { xs: 'none', sm: 3 },
                        position: 'relative'
                    }}
                >
                    <IconButton
                        onClick={() => navigate('/sign-in')}
                        sx={{
                            position: 'absolute',
                            top: 16,
                            left: 16,
                            zIndex: 1
                        }}
                    >
                        <ArrowBackIcon />
                    </IconButton>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', mx: 'auto' }}>
                        <img className="w-60" src="assets/images/logo/logo.svg" alt="logo" />
                        <Typography sx={{ mt: 2, textAlign: 'center' }}>
                            Unauthenticated Access
                        </Typography>
                    </Box>
                </Paper>
            </div>
        );
    }

    return (
        <div className="flex flex-col items-center flex-auto min-w-0 sm:justify-center">
            <Paper
                sx={{
                    minwidth: '60vw',
                    minHeight: '100%',
                    overflow: "auto",
                    px: { xs: 2, sm: 4 },
                    py: { xs: 4, sm: 6 },
                    borderRadius: { xs: 0, sm: 2 },
                    boxShadow: { xs: 'none', sm: 3 },
                    position: 'relative'
                }}
            >
                <IconButton
                    onClick={() => navigate('/sign-in')}
                    sx={{
                        position: 'absolute',
                        top: 16,
                        left: 16,
                        zIndex: 1
                    }}
                >
                    <ArrowBackIcon />
                </IconButton>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', mx: 'auto' }}>
                    <img className="w-60" src="assets/images/logo/logo.svg" alt="logo" />
                    <TwoFaSetupStepper
                        email={email}
                        password={password}
                        onSuccess={handleVerifySuccess}
                        onError={handleVerifyError}
                    />
                </Box>
            </Paper>
        </div>
    );
}

export default TwoFaStepperPage;

